<template>
  <div class="blog-posts-page posts">
    <div>
      <div class="post-list-header row pt-3  align-items-center">
        <div
          class="page-header col-12 d-flex justify-content-between align-items-center"
        >
          <div class="page-header-left d-flex align-items-center">
            <h1 class="w-full mr-2">Posts</h1>
          </div>
          <div class="input-group search">
            <input
              class="form-control"
              type="search"
              v-model="keyword"
              placeholder="Search title, subtitle or slug"
              aria-label="Search posts"
              @input="searchText"
              @keyup.enter="applySearch"
            />
            <button
              type="button"
              class="btn input-group-btn"
              :aria-label="keyword ? 'Clear search' : 'Search'"
              @click="clearSearch"
            >
              <i :class="[keyword ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
          </div>
          <span
            class="header-right-side d-flex justify-content-center align-items-center"
          >
            <button
              @click.prevent="triggerDeployment()"
              class="btn btn-primary mr-4"
            >
              Deploy Posts
            </button>
            <button
              class="btn btn-primary mr-4"
              @click.prevent="$router.push('/posts/new')"
            >
              <b>Create New Post</b>
            </button>
            <button
              type="button"
              class="btn btn-secondary expand-all d-flex align-items-center"
              @click="toggleAllPosts"
            >
              <div
                :class="[
                  blogPosts && blogPosts.length === expanded.length
                    ? 'expand-icon'
                    : 'compress-icon'
                ]"
              />
            </button>
          </span>
        </div>

        <div class="filter-bar col-12" role="toolbar" aria-label="Post filters">
          <fieldset
            v-for="group in filterGroups"
            :key="group.key"
            class="filter-group"
          >
            <legend class="filter-group__label">{{ group.label }}</legend>
            <div class="segmented" role="radiogroup" :aria-label="group.label">
              <button
                v-for="opt in group.options"
                :key="String(opt.value)"
                type="button"
                class="segmented__item"
                :class="{
                  'is-active': filters[group.key] === opt.value,
                  'is-draft': group.key === 'status' && opt.value === 'draft',
                  'is-published':
                    group.key === 'status' && opt.value === 'published'
                }"
                role="radio"
                :aria-checked="filters[group.key] === opt.value"
                @click="setFilter(group.key, opt.value)"
              >
                <i
                  v-if="group.key === 'status' && opt.value"
                  class="fa fa-circle segmented__dot"
                  aria-hidden="true"
                />
                <img
                  v-if="opt.flag"
                  class="segmented__flag"
                  :src="
                    require(`../../assets/img/filters/flags/${opt.flag}.png`)
                  "
                  alt=""
                />
                {{ opt.label }}
              </button>
            </div>
          </fieldset>

          <div class="filter-bar__summary">
            <span
              v-if="meta.pagination && !postsLoading"
              class="filter-bar__count"
              aria-live="polite"
            >
              {{ meta.pagination.total }}
              {{ meta.pagination.total === 1 ? "post" : "posts" }}
            </span>
            <button
              v-if="activeFilterCount"
              type="button"
              class="filter-bar__clear"
              @click="clearFilters"
            >
              <i class="fa fa-times" aria-hidden="true" />
              Clear {{ activeFilterCount }}
              {{ activeFilterCount === 1 ? "filter" : "filters" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <template v-if="blogPosts && postsLoading">
      <vue-content-loading :width="800" :height="450">
        <rect
          v-for="x in 15"
          :key="x"
          x="10"
          :y="15 * x * 1.4"
          rx="5"
          ry="5"
          width="720"
          height="6"
        />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="mt-4" v-for="post in blogPosts" :key="post.id">
        <div class="post-container">
          <div class="d-flex post-header col-12 align-items-center">
            <div
              class="w-full d-flex align-items-center justify-content-between col-md-8 col-12"
            >
              <div
                class="w-full d-flex align-items-center post-title pointer"
                @click.middle.exact="viewMiddle($event, post.id)"
                @click.left.exact="view($event, post.id)"
              >
                {{ post.title }}
              </div>
              <div>
                <span v-if="post.user.id === 1">Marko</span>
                <span v-else>Bojan</span>
              </div>
              <div
                class="w-full d-flex align-items-center justify-content-center "
              >
                <span class="post-status" v-if="!post.is_draft"
                  ><i class="fa fa-circle green"></i> Published</span
                >
                <span class="post-status" v-else
                  ><i class="fa fa-circle red"></i> Draft</span
                >
              </div>
            </div>

            <div
              class="w-full d-flex align-items-center justify-content-between col-12 col-lg-4 pr-0"
            >
              <div class="w-full d-flex align-items-center col-2 col-md-4">
                <img
                  class="flag-img"
                  :src="
                    require(`../../assets/img/filters/flags/${post.lang}.png`)
                  "
                />
              </div>
              <div
                class="w-full d-flex align-items-center justify-content-end  col-2 col-md-4 pr-0"
              >
                <div class="options-buttons d-flex">
                  <div class="dropdown mr-2">
                    <button
                      class="btn btn-secondary dots-btn"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-right"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div
                        class="pointer d-flex align-items-center dropdown-item pointer"
                        @click="$router.push('/post/' + post.id + '/comments')"
                      >
                        <i class="fa fa-comments-o mr-2"></i>
                        Comments ({{ post.comment_count }})
                      </div>
                      <div
                        class="d-flex align-items-center dropdown-item pointer"
                        @click.prevent="
                          $router.push({
                            name: 'New blog post',
                            params: { duplicatedPost: post }
                          })
                        "
                      >
                        <i class="fa fa-files-o mr-2"></i> Duplicate
                      </div>
                      <div
                        class="d-flex align-items-center dropdown-item pointer"
                        @click="deletePost(post.id)"
                      >
                        <i class="fa fa-trash mr-2 text-danger"></i> Delete
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn btn-secondary"
                    @click="togglePost(post.id)"
                  >
                    <i
                      class="fa fa-caret-down caret"
                      :class="{ rotate: !expanded.includes(post.id) }"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr :class="[!expanded.includes(post.id) ? '' : 'hidden']" />
          <div
            class="post-expanded d-flex flex-row"
            :class="[!expanded.includes(post.id) ? '' : 'hidden']"
          >
            <div class="d-flex flex-row justify-content-start col-12 col-md-8">
              <div class="d-flex flex-column">
                <div class="expander-title">Post description</div>
                <div class="expander-description">
                  {{ post.meta_description }}
                </div>
              </div>
            </div>
            <div class=" d-flex flex-column justify-content-start col-4">
              <div class="h-full d-flex flex-row justify-content-between">
                <div
                  class="col-6 d-flex flex-column justify-content-between"
                  v-if="post.tags && post.category"
                >
                  <div>
                    <div class="expander-title">Tags</div>
                    <div class="expander-description">
                      <span
                        v-for="(tag, index) in post.tags.data"
                        :key="tag.id"
                      >
                        {{ tag.tag }}<span v-if="index - 1 !== 0">,</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <div class="expander-title">Category</div>
                    <div class="expander-description">
                      {{ post.category.data.name }}
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between flex-column alig-items-center"
                >
                  <div>
                    <div class="expander-title">Updated at</div>
                    <div class="expander-description">
                      {{ post.updated_at }}
                    </div>
                  </div>
                  <div></div>
                </div>

                <div>
                  <div class="expander-title"></div>
                  <div class="expander-description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="blogPosts && !blogPosts.length && !postsLoading"
        class="posts-empty"
      >
        <p class="posts-empty__title">No posts match these filters</p>
        <button
          v-if="activeFilterCount"
          type="button"
          class="btn btn-secondary posts-empty__action"
          @click="clearFilters"
        >
          Clear filters
        </button>
      </div>

      <div class="row">
        <div
          class="col-md-6 mb-1 text-black-50"
          v-if="meta.pagination && meta.pagination.total"
        >
          Showing
          {{
            (meta.pagination.current_page - 1) * meta.pagination.per_page + 1
          }}
          -
          {{
            (meta.pagination.current_page - 1) * meta.pagination.per_page +
              meta.pagination.count
          }}
          of {{ meta.pagination.total }}
        </div>
        <pagination
          class="col-md-6 mb-1"
          :change-page="changePage"
          :meta="meta"
        />
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Pagination from "@/components/Pagination";
/*
  import flatPickr from 'vue-flatpickr-component';*/

export default {
  name: "BlogPosts",
  components: {
    Pagination
  },
  data: () => ({
    blogPosts: null,
    expanded: [],
    keyword: "",
    meta: {},
    postsLoading: false,
    timer: null,
    filters: { status: "", author: "", lang: "", q: "", page: 1 },
    filterGroups: [
      {
        key: "status",
        label: "Status",
        options: [
          { value: "", label: "All" },
          { value: "published", label: "Published" },
          { value: "draft", label: "Draft" }
        ]
      },
      {
        key: "author",
        label: "Author",
        options: [
          { value: "", label: "All" },
          { value: "1", label: "Marko" },
          { value: "3", label: "Bojan" }
        ]
      },
      {
        key: "lang",
        label: "Language",
        options: [
          { value: "", label: "All" },
          { value: "sr", label: "SR", flag: "sr" },
          { value: "en", label: "EN", flag: "en" },
          { value: "de", label: "DE", flag: "de" }
        ]
      }
    ]
  }),
  computed: {
    activeFilterCount() {
      const { status, author, lang, q } = this.filters;
      return [status, author, lang, q].filter(Boolean).length;
    }
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler() {
        this.readRoute();
        this.fetchPosts();
      }
    }
  },
  methods: {
    // The URL query is the single source of truth: every control writes to it
    // and the watcher above reloads, so back/forward and shared links work.
    readRoute() {
      const q = this.$route.query;
      this.filters = {
        status: ["draft", "published"].includes(q.status) ? q.status : "",
        author: q.author ? String(q.author) : "",
        lang: ["sr", "en", "de"].includes(q.lang) ? q.lang : "",
        q: q.q ? String(q.q) : "",
        page: Math.max(1, parseInt(q.page, 10) || 1)
      };
      this.keyword = this.filters.q;
    },
    writeRoute(next) {
      const query = {};
      Object.entries({ ...this.filters, ...next }).forEach(([k, v]) => {
        if (k === "page") {
          if (v > 1) query.page = String(v);
        } else if (v) {
          query[k] = String(v);
        }
      });
      this.$router.replace({ query }).catch(() => {});
    },
    setFilter(key, value) {
      if (this.filters[key] === value) return;
      this.writeRoute({ [key]: value, page: 1 });
    },
    fetchPosts() {
      this.postsLoading = true;
      const { status, author, lang, q, page } = this.filters;
      const params = new URLSearchParams({ include: "tags,category", page });
      if (status) params.set("status", status);
      if (author) params.set("author", author);
      if (lang) params.set("lang", lang);
      if (q) params.set("keyword", q);

      axios
        .get(`/posts?${params}`)
        .then(resp => {
          this.blogPosts = resp.data.data;
          this.meta = resp.data.meta;
          this.postsLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.postsLoading = false;
        });
    },
    deletePost(postId) {
      axios
        .delete(`/posts/${postId}`)
        .then(() => {
          this.fetchPosts();
        })
        .catch(error => {
          console.log(error);
        });
    },
    togglePost(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllPosts() {
      if (!this.expanded.length) {
        this.blogPosts.forEach(post => {
          this.expanded.push(post.id);
        });
      } else {
        this.expanded = [];
      }
    },
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/posts/${id}`
      });
      window.open(routeData.href, "_blank");
    },
    view(event, id) {
      this.$router.push(`/posts/${id}`);
    },
    changePage(pageNum) {
      this.blogPosts = {};
      this.writeRoute({ page: pageNum });
    },
    searchText() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.applySearch, 400);
    },
    applySearch() {
      clearTimeout(this.timer);
      const q = this.keyword.trim();
      if (q === this.filters.q) return;
      this.writeRoute({ q, page: 1 });
    },
    clearSearch() {
      this.keyword = "";
      this.applySearch();
    },
    clearFilters() {
      this.keyword = "";
      this.writeRoute({ status: "", author: "", lang: "", q: "", page: 1 });
    }
  }
};
</script>
<style scoped>
.filters-header {
  width: fit-content;
}
.dropdown-menu {
  min-width: auto;
}
.search {
  position: relative;
  max-width: 300px;
}
.search .form-control {
  padding-left: 35px;
  height: 42px;
  z-index: 10;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.search button,
.search .form-control {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  border: 0;
  background-color: transparent;
  outline: none;
}
.search button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  height: 42px;
}
.blog-posts-page .input-group.search {
  height: 42px;
}

@media screen and (max-width: 800px) {
  .blog-posts-page.posts {
    padding: 0 20px;
  }
  .post-list-header {
    padding-top: 0 !important;
  }
  .page-header-left h1 {
    text-align: center;
  }
  .blog-posts-page .input-group.search {
    margin: 0;
  }
  .header-right-side {
    margin-top: 20px;
  }
}
:root {
  --cms-teal: #006266;
  --cms-teal-soft: rgba(0, 98, 102, 0.08);
  --cms-ink: #212529;
  --cms-ink-2: #4c5669;
  --cms-ink-3: #808d98;
  --cms-line: #c4cdd5;
  --cms-surface: #ffffff;
  --cms-surface-2: #f9fafb;
  --cms-green: #28a745;
  --cms-red: #dc3545;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 28px;
  margin: 18px 0 6px;
  padding: 14px 16px 12px;
  background: var(--cms-surface);
  border: 1px solid #e0e5ea;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(22, 29, 37, 0.06);
}

.filter-group {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}
.filter-group__label {
  float: none;
  width: auto;
  margin: 0 0 6px;
  padding: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cms-ink-3);
}

.segmented {
  display: inline-flex;
  padding: 3px;
  background: var(--cms-surface-2);
  border: 1px solid var(--cms-line);
  border-radius: 6px;
}
.segmented__item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: var(--cms-ink-2);
  cursor: pointer;
  transition: background-color 140ms cubic-bezier(0.2, 0, 0, 1),
    color 140ms cubic-bezier(0.2, 0, 0, 1),
    box-shadow 140ms cubic-bezier(0.2, 0, 0, 1);
}
.segmented__item:hover {
  color: var(--cms-teal);
  background: var(--cms-teal-soft);
}
.segmented__item:focus-visible {
  outline: 2px solid var(--cms-teal);
  outline-offset: 1px;
}
.segmented__item.is-active {
  color: var(--cms-teal);
  background: var(--cms-surface);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(22, 29, 37, 0.12), 0 0 0 1px rgba(0, 98, 102, 0.28);
}
.segmented__dot {
  font-size: 8px;
  color: var(--cms-line);
  transition: color 140ms cubic-bezier(0.2, 0, 0, 1);
}
.segmented__item.is-published.is-active .segmented__dot,
.segmented__item.is-published:hover .segmented__dot {
  color: var(--cms-green);
}
.segmented__item.is-draft.is-active .segmented__dot,
.segmented__item.is-draft:hover .segmented__dot {
  color: var(--cms-red);
}
.segmented__flag {
  width: 20px;
  height: 13px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(22, 29, 37, 0.12);
}

.filter-bar__summary {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
  padding-bottom: 8px;
  font-size: 14px;
  color: var(--cms-ink-2);
}
.filter-bar__count {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.filter-bar__clear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--cms-red);
  cursor: pointer;
  white-space: nowrap;
}
.filter-bar__clear:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.filter-bar__clear:focus-visible {
  outline: 2px solid var(--cms-teal);
  outline-offset: 2px;
  border-radius: 2px;
}

.posts-empty {
  margin-top: 16px;
  padding: 40px 24px;
  text-align: center;
  background: var(--cms-surface);
  border: 1px dashed var(--cms-line);
  border-radius: 4px;
}
.posts-empty__title {
  margin: 0 0 12px;
  font-size: 16px;
  color: var(--cms-ink-2);
}
.blog-posts-page .posts-empty__action.btn.btn-secondary {
  width: auto;
  height: 38px;
  padding: 0 16px;
  color: var(--cms-teal);
  background: var(--cms-surface-2);
  border: 1px solid var(--cms-line);
}

/* language flag in each post row */
.post-header .flag-img {
  width: 32px;
  height: 20px;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(22, 29, 37, 0.12);
}

.search .form-control::placeholder {
  color: var(--cms-ink-3);
}
.search .form-control:focus-visible {
  box-shadow: 0 0 0 2px var(--cms-teal-soft);
}

@media screen and (max-width: 800px) {
  .filter-bar {
    padding: 12px;
    gap: 12px 20px;
  }
  .segmented__item {
    padding: 0 10px;
  }
  .filter-bar__summary {
    width: 100%;
    margin-left: 0;
    padding-bottom: 0;
    justify-content: space-between;
  }
}
</style>
